import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const FillerMaterialBoxStyled = styled(Box).attrs({
  my: { sm: '200' },
  justifyContent: { sm: 'space-between' },
  alignItems: { sm: 'center' },
  pr: { sm: '400' },
})`
  ${({ theme }) => css`
    background: ${theme.colors.grey[100]};
    border: 1px dashed ${theme.colors.grey[300]};
    border-radius: ${theme.spacings[200]};
  `}
`;
